var _style, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowNButtonRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 137 88",
    style: {
      enableBackground: "new 0 0 137 88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#7D1717;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Screens"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_x5F_09_x5F_ASSIST_x5F_Lenkstockhebel_x5F_Hinweis",
    transform: "translate(-1032.000000, -605.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow-_x26_-Button",
    transform: "translate(1032.000000, 605.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Button",
    className: "st0",
    d: "M32.2,54c-4.5,0.2-7.2,0.5-7.2,4.2s2.4,9.4,6.2,10.7c2.5,0.9,5.8,1.2,9.8,1 C38.1,59.2,35.2,53.8,32.2,54z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Arrow",
    className: "st0",
    points: "0,44 12.9,56.9 0,69.8  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowNButtonRed);
export default __webpack_public_path__ + "static/media/icon-arrow_n_button_Red.0f87f0b1bc2b2975cbe5652164bdfb1f.svg";
export { ForwardRef as ReactComponent };